module.exports = __webpack_public_path__ + "static/media/kitchen4.3c7262a2.png";